<template>
  <v-container fluid dense>
    <v-row justify="start">
      <v-col>
        <snipplet-import
          id="ordini"
          categoria="Ordini"
          descrizione="Carica i file zip e importa gli ordini"
          comando="Importa Ordini"
        >
        </snipplet-import>
      </v-col>
      <v-col>
        <snipplet-import
          id="packing"
          categoria="Packing"
          descrizione="Carica i file zip e importa le packing list"
          comando="Importa Packing"
        >
        </snipplet-import>
      </v-col>
      <v-col>
        <snipplet-import
          id="categorie"
          categoria="Categorie"
          descrizione="Aggiorna le categorie in base ai dati importati"
          comando="Aggiorna Categorie"
        >
        </snipplet-import>
      </v-col>      
<!--       <v-col md="2">
        <snipplet-import
          id="causali"
          dbRemote="configurazioni"
          categoria="Causali di Magazzino"
          descrizione="Importa le causali di magazzino accodandole alle esistenti"
          :modello="modello"
          :cliente="cliente">
        </snipplet-import>
      </v-col> -->
<!--       <v-col md="2">
        <snipplet-import
          id="movimenti"
          dbRemote="movimenti"
          categoria="Movimenti e Scontrini"
          descrizione="Importa movimenti e scontrini"
          :modello="modello"
          :cliente="cliente">
        </snipplet-import>
      </v-col> -->
      <v-spacer></v-spacer>
    </v-row>
  </v-container>  
</template>

<script>
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import SnippletImport from './snippletImport.vue'
  /* import SnippletMigrazioneScelta from './snippletMigrazioneScelta.vue' */

  export default {
    components: {
      SnippletImport
    },
    props: {
      cliente: Object
    },
    mixins: [verificaLicenza],
    data (vm) {
      return {
        modello: ''
      }
    },
    async mounted() {
      await this.verificaModuliLocali()
    },
    methods: {
      changeScelta(value) {
        this.modello = value
      }
    }
  }
  </script>
